import React, { useState } from "react";
import "./StatisBar.scss";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import ProducerHubFilter from "@components/ProducerHubFilter/ProducerHubFilter";
import {
  incomeDatasets,
  orderDatasets,
  productDatasets,
  ratingDatasets,
  visitorDatasets,
} from "@utils/mockDataset";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

interface IStatisBar {
  selectedAnalysBox: number;
}

const StatisBar: React.FC<IStatisBar> = ({ selectedAnalysBox }) => {
  const [selectedOption, setSelectedOption] = useState({ date: 1 });

  const data = {
    labels: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
    ],
    datasets:
      selectedAnalysBox === 1
        ? incomeDatasets
        : selectedAnalysBox === 2
        ? productDatasets
        : selectedAnalysBox === 3
        ? orderDatasets
        : selectedAnalysBox === 4
        ? visitorDatasets
        : ratingDatasets,
  };

  const options: any = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      title: { display: false },
    },
    scales: {
      x: {
        stacked: selectedAnalysBox === 5 ? false : true,
      },
      y: {
        stacked: selectedAnalysBox === 5 ? false : true,
        beginAtZero: true,
      },
    },
  };

  return (
    <div className="StatisBar">
      <ProducerHubFilter
        selectedOption={selectedOption}
        setSelectedOption={setSelectedOption}
        isLeaderboard={false}
      />
      <div className="BarGroup">
        <Bar data={data} options={options} />
      </div>
    </div>
  );
};

export default StatisBar;
